module.exports = __webpack_public_path__ + "static/media/IMG_4410.60686e2b.jpg";